module.exports = "<p>\n  job works!\n</p>\n"